import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import logo from "../../assets/logo-removebg-preview.svg";
import ChangePasswordForm from "../../components/ChangePasswordForm";
import { useSeller } from "../../providers/users";
import { Container } from "./styles";

const ChangePassword = () => {
  const { token } = useSeller();
  const navigate = useNavigate();
  const { path } = useParams();
  const forceChangePassword =
    window.localStorage.getItem("SPP-FORCE-CHANGE-PASSWORD") || "";

  useEffect(() => {
    if (!forceChangePassword) {
      navigate(`/${path}`);
    }
  }, [forceChangePassword]);
  return (
    <Container>
      <header>
        <img src={logo} alt="SPP Logo" className="loginLogo" />
      </header>
      <main>
        <ChangePasswordForm />
      </main>
    </Container>
  );
};

export default ChangePassword;
